import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

/**
 * モバイル UA 検出 → 対応する /mobile/* へ自動リダイレクト
 * ラップ対象: PC 版全ページ（AdminLayout の各ページ）
 *
 * ルール:
 * - iPhone / iPad / iPod / Android → /mobile/{現在のパス} へジャンプ
 * - PC / 不明 → 子要素をそのまま表示
 */
const isMobileUA = (): boolean => {
  if (typeof navigator === "undefined") return false;
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
};

type Props = {
  children: ReactNode;
};

export const MobileDetectRedirect = ({ children }: Props) => {
  const location = useLocation();

  // Mobile routes are already normalized; do not prefix /mobile again.
  if (location.pathname === "/mobile" || location.pathname.startsWith("/mobile/")) {
    return <>{children}</>;
  }

  if (isMobileUA()) {
    // "/" → "/mobile/dashboard" のように、対応する mobile パスへ変換
    const target = "/mobile" + (location.pathname === "/" ? "/dashboard" : location.pathname);
    return <Navigate to={target} replace />;
  }

  return <>{children}</>;
};
